var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{on:{"click":_vm.exec}},[_vm._v("Exec")]),_c('br'),_c('br'),_c('Meal',{style:({ width: "300px" }),attrs:{"meal":{
      title: 'meal title',
      ingredients: [
        'test',
        'gresferd',
        'test',
        'test',
        'gresferdfe',
        'test',
        'gr',
        'test' ],
    },"clickable":false,"updatable":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }